// extracted by css-extract-rspack-plugin
export default {"placeholderContainer":"omnibar-placeholder-module__placeholderContainer__FSzfdRm","placeholderText":"omnibar-placeholder-module__placeholderText__Rl83R0M"};